import { AlertTriangle, Send } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PendingActionsBannerProps {
  pendingCount: number;
  onSubmitClick: () => void;
}

export function PendingActionsBanner({
  pendingCount,
  onSubmitClick,
}: PendingActionsBannerProps) {
  if (pendingCount === 0) return null;

  return (
    <div className="flex items-center justify-between bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5 text-yellow-600" />
        <span className="text-sm text-yellow-800">
          Tienes <strong>{pendingCount}</strong> documento
          {pendingCount > 1 ? "s" : ""} pendiente{pendingCount > 1 ? "s" : ""} de
          envío
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="border-yellow-600 text-yellow-700 hover:bg-yellow-100"
        onClick={onSubmitClick}
      >
        <Send className="mr-2 h-4 w-4" />
        Enviar a SII
      </Button>
    </div>
  );
}
